import { SFStack, SFGridContainer, SFGridItem } from "../grid";
import SFTypography from "../typography";
import SFHaloIconWrapper from "../icons/halo";
import { SFAccountTreeIcon } from "../icons";
import PropTypes from "prop-types";
import SFLink from "../link";

export const SFBadgeIcon = ({
  icon,
  label,
  variant,
  ignoreIcon,
  description,
  component = null,
  className = null,
  onClick,
  href,
}) => {
  return (
    <SFStack
      direction="row"
      alignItems="center"
      spacing={1}
      className={className}
    >
      {icon && (
        <SFHaloIconWrapper
          size="small"
          variant={variant}
          ignoreIcon={ignoreIcon}
        >
          {icon}
        </SFHaloIconWrapper>
      )}
      <SFStack direction="column" alignItems="flex-start">
        <SFTypography variant="textLabel">{label}</SFTypography>
        {onClick || href ? (
          <SFLink onClick={onClick} href={href}>
            <SFTypography variant="textValue" color="blue400">
              {description}
            </SFTypography>
          </SFLink>
        ) : (
          <SFStack>
            <SFTypography variant="textValue">{description}</SFTypography>
          </SFStack>
        )}

        {component}
      </SFStack>
    </SFStack>
  );
};

const SFBadgeIcons = ({ badges, showHierarchy = false, maxItems = "auto" }) => {
  if (!badges) {
    return null;
  }

  const breakpointsVariants = {
    3: {
      xs: 12 / 1,
      sm: 12 / 1,
      md: 12 / 2,
      lg: 12 / 2,
      xl: 12 / 3,
      xxl: 12 / 3,
    },
    4: {
      xs: 12 / 1,
      sm: 12 / 2,
      md: 12 / 3,
      lg: 12 / 3,
      xl: 12 / 4,
      xxl: 12 / 4,
    },
    6: {
      xs: 12 / 1,
      sm: 12 / 2,
      md: 12 / 3,
      lg: 12 / 3,
      xl: 12 / 6,
      xxl: 12 / 6,
    },
    auto: {
      xs: 12 / 1,
      sm: 12 / 2,
      md: 12 / 3,
      lg: "auto",
      xl: "auto",
      xxl: "auto",
    },
  };

  return (
    <SFGridContainer columnSpacing={1} spacing={0}>
      {showHierarchy && (
        <SFGridItem xs="auto">
          <SFHaloIconWrapper size="small" variant="lightblue" ignoreIcon>
            <SFAccountTreeIcon size="inherit" color="blue300" />
          </SFHaloIconWrapper>
        </SFGridItem>
      )}
      <SFGridItem xs>
        <SFGridContainer columnSpacing={4} spacing={2}>
          {badges.map((badge, index) => (
            <SFGridItem key={index} {...breakpointsVariants[maxItems]}>
              <SFBadgeIcon
                icon={badge.icon}
                iconColor={badge.iconColor}
                label={badge.label}
                description={badge.description}
                component={badge.component}
                variant={badge.variant}
                ignoreIcon={badge.ignoreIcon}
                onClick={badge.onClick}
                href={badge.href}
              />
            </SFGridItem>
          ))}
        </SFGridContainer>
      </SFGridItem>
    </SFGridContainer>
  );
};

SFBadgeIcons.propTypes = {
  badges: PropTypes.array.isRequired,
  showHierarchy: PropTypes.bool,
  hideIcon: PropTypes.bool,
  maxitems: PropTypes.oneOf(["auto", 3, 4, 6]),
};

export default SFBadgeIcons;
